import React from "react";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import ModalHeader from "@dhn/components/molecules/modal-header";
import StatusBadge from "@dhn/components/molecules/status-badge";
import ActionButton from "@dhn/components/molecules/action-button";
import DetailList, { DetailChips } from "@dhn/components/molecules/detail-list";
import { SectionSubtitle } from "@dhn/components/molecules/section-header";
import useDoctorProfileDetails from "../hooks/useDoctorProfileDetails";

const LOADING_TEXT = "Cargando...";

export default function DoctorProfileModal({ isOpen, onClose, dataDoctor, user }) {
  const details = useDoctorProfileDetails({ isOpen, dataDoctor, user });
  const withLoading = (fields) =>
    fields.map((field) => ({
      ...field,
      value: details.loading ? LOADING_TEXT : field.value,
    }));

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="lg" centered>
      <ModalHeader
        toggle={onClose}
        iconClass="fa-user-md"
        description={details.fullName}
        subtitle="Revise los datos del médico y de su consultorio."
      />
      <ModalBody>
        <SectionSubtitle>Consultorio y sucursal</SectionSubtitle>
        <DetailList
          items={[
            ...details.officeFields,
            {
              label: "Administrador",
              value: (
                <StatusBadge color={details.isAdmin ? "success" : "secondary"}>
                  {details.isAdmin ? "Sí" : "No"}
                </StatusBadge>
              ),
            },
            {
              label: "Estado",
              value: (
                <StatusBadge color={details.isEnabled ? "success" : "secondary"}>
                  {details.isEnabled ? "Activo" : "Inactivo"}
                </StatusBadge>
              ),
            },
          ]}
        />

        <SectionSubtitle>Datos del médico</SectionSubtitle>
        <DetailList
          items={withLoading([
            ...details.personalFields,
            { label: "Dirección", value: details.address, wide: true },
          ])}
        />

        <SectionSubtitle>Especialidades</SectionSubtitle>
        <DetailChips
          items={details.specialities.map(({ name }) => name)}
          emptyText={details.loading ? LOADING_TEXT : "No hay especialidades registradas."}
        />

        <SectionSubtitle>ARS y código de prestador</SectionSubtitle>
        {details.arses.length ? (
          <DetailList
            items={details.arses.map((ars) => ({ label: ars.name, value: ars.code }))}
          />
        ) : (
          <DetailChips
            emptyText={details.loading ? LOADING_TEXT : "No hay ARS registradas."}
          />
        )}
      </ModalBody>
      <ModalFooter>
        <ActionButton action="close" onClick={onClose} />
      </ModalFooter>
    </Modal>
  );
}
